import { fromJS } from 'immutable';
import { VIEW_GET_INFO_LOADED } from '../../../actions/Entity/View';
var initialState = fromJS({});
export default function viewInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case VIEW_GET_INFO_LOADED:
      {
        return state.set(action.payload.viewId, fromJS(action.payload.viewInfo));
      }
    default:
      return state;
  }
}